import { CATEGORIES } from 'constants/fromLocalStorage'
import { hasStorage } from 'helpers/LocalStorageHelper'
import { GetStateFromLocalStorage } from './fromLocalStorage.types'

export const getStateFromLocalStorage: GetStateFromLocalStorage = () => {
  if (!hasStorage) { return {} }

  return Object.keys(localStorage).reduce((state, lsKey) => {
    const [category, subCategory] = lsKey.split('-')

    return (CATEGORIES.includes(category))
      ? {
          ...state,
          [category]: {
            ...state[category],
            [subCategory]: JSON.parse(localStorage.getItem(lsKey) ?? '{}')
          }
        }
      : state
  }, {})
}
